var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer footer-static footer-light navbar-border"},[_c('div',[_c('center',[_vm._v("\n        © "+_vm._s(_vm.year)+" made with "),_c('i',{staticClass:"icon-heart3"}),_vm._v(" by "),_c('a',[_vm._v("Modern-Expo IT TEAM")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-884d23f0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 316
// module chunks = 0